import styled from "styled-components";

function BnToggle(props: {
  setIsVeiw: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  return (
    <BtnWrap onClick={() => props.setIsVeiw((prev) => !prev)}>
      <div>Open</div>
      <i />
    </BtnWrap>
  );
}

export default BnToggle;

const BtnWrap = styled.button`
  background: #4870ec;
  color: #fff;
  text-transform: none;
  min-width: auto;
  height: auto;
  padding: 0.375rem 1.25rem;
  border-radius: 10px;
  margin-bottom: 0;

  &:hover {
    background: #b553ff;
    color: #fff;
  }

  div {
    display: inline-block;
    margin-bottom: 3px;
  }

  i {
    background-image: url(//file.valofe.com/Valofe_file/web/vfun/images/vfun_lounge/images/square-arrow-down.png);
    background-repeat: no-repeat;
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-left: 10px;
  }
`;
